import { render, staticRenderFns } from "./NewRawMaterialCategory.vue?vue&type=template&id=6636785e&scoped=true"
import script from "./NewRawMaterialCategory.vue?vue&type=script&lang=js"
export * from "./NewRawMaterialCategory.vue?vue&type=script&lang=js"
import style0 from "./NewRawMaterialCategory.vue?vue&type=style&index=0&id=6636785e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6636785e",
  null
  
)

export default component.exports